import TendrilLogoColor from './icons/tendril-logo-color.svg';
import TendrilLogoWhite from './icons/tendril-logo-white.svg';
import TendrilColorSlogan from './icons/tendril-color-slogan.svg';
import Tendril404 from './icons/tendril404.svg';
import OutreachLogo from './icons/outreach-logo.svg';
import SalesforceLogo from './icons/salesforce-logo.svg';
import HubspotLogo from './icons/hubspot-logo.svg';

export const TendrilLogoColorTyped: string = TendrilLogoColor;
export const TendrilLogoWhiteTyped: string = TendrilLogoWhite;
export const TendrilColorSloganTyped: string = TendrilColorSlogan;
export const Tendril404Typed: string = Tendril404;

export const OutreachLogoTyped: string = OutreachLogo;

export const SalesforceLogoTyped: string = SalesforceLogo;

export const HubspotLogoTyped: string = HubspotLogo;

